import { render, staticRenderFns } from "./RealEstateDataTab.vue?vue&type=template&id=1545e9c6&scoped=true"
import script from "./RealEstateDataTab.vue?vue&type=script&lang=js"
export * from "./RealEstateDataTab.vue?vue&type=script&lang=js"
import style0 from "./RealEstateDataTab.vue?vue&type=style&index=0&id=1545e9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545e9c6",
  null
  
)

export default component.exports